import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, formatApiError } from '@/lib/api';
import { recordWebsiteEvent } from '@/lib/website-analytics';

export default function ContactForm() {
  const [busy,setBusy] = useState(false);
  const [error,setError] = useState('');
  const [receipt,setReceipt] = useState('');
  const submission = useRef(null);
  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    const form = event.currentTarget;
    const fields = new FormData(form);
    submission.current ||= crypto.randomUUID();
    setBusy(true); setError('');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${API}/public/contact`, {method:'POST',signal:controller.signal,credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({
        name:fields.get('name'),email:fields.get('email'),organization:fields.get('organization'),message:fields.get('message'),website:fields.get('website'),receipt:submission.current,
      })});
      const data = await response.json();
      if (!response.ok || !data.stored) throw new Error(formatApiError(data.detail,'We could not send your inquiry. Please try again or email admin@jennaemichelle.com.'));
      setReceipt(data.receipt); recordWebsiteEvent('contact_submit'); form.reset(); submission.current = null;
    } catch (err) { setError(err.name === 'AbortError' ? 'The connection timed out. Please retry; your reference prevents a duplicate inquiry.' : err.message || 'Please try again or email admin@jennaemichelle.com.'); }
    finally { clearTimeout(timeout); setBusy(false); }
  }
  return <section className="jmh-section" aria-labelledby="contact-inquiry-heading">
    <div className="jmh-reading-shell jmh-contact-form-wrap corner-frame">
      <h2 id="contact-inquiry-heading" className="font-display gold-text">Send an inquiry</h2>
      <p className="jmh-contact-form-intro">Your message goes to the Jennae Michelle Holdings Founder Office for review. Please avoid sending confidential medical, legal, or financial records through this form.</p>
      <form onSubmit={submit} className="jmh-contact-form" aria-busy={busy}>
        <div><label htmlFor="contact-name">Name</label><input id="contact-name" name="name" autoComplete="name" required minLength={2} maxLength={120} /></div>
        <div><label htmlFor="contact-email-input">Email</label><input id="contact-email-input" name="email" type="email" autoComplete="email" required maxLength={254} /></div>
        <div><label htmlFor="contact-organization">Organization (optional)</label><input id="contact-organization" name="organization" autoComplete="organization" maxLength={200} /></div>
        <div><label htmlFor="contact-message">Question or circumstances</label><textarea id="contact-message" name="message" rows={6} minLength={10} maxLength={5000} required aria-describedby="contact-form-privacy" /></div>
        <div className="jmh-form-trap" aria-hidden="true"><label htmlFor="contact-website">Leave this field empty</label><input id="contact-website" name="website" tabIndex={-1} autoComplete="off" /></div>
        <p id="contact-form-privacy">We use these details to review and respond to your inquiry. See our <Link to="/privacy" className="link-underline">Privacy Policy</Link>. Submission does not create an advisory relationship.</p>
        {error && <p role="alert" className="jmh-form-error">{error}</p>}
        {receipt && <div role="status" data-testid="contact-receipt"><p>Your inquiry has been received in the Founder Office inbox.</p><p>Reference: {receipt}</p></div>}
        <button type="submit" disabled={busy} className="jmh-cta">{busy ? 'Sending…' : 'Send inquiry'}</button>
      </form>
    </div>
  </section>;
}
